import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Box, ButtonGroup, Card, Grid, IconButton, Typography } from '@mui/material';
import { subjectGroupsFromAgendas, transformGroups } from 'app/utils/appHelpers';
import { departmentCardColor, departmentCardTextColor } from 'config';
import { useSelector } from 'react-redux';
import SubjectTooltipTable from '../Table/SubjectTooltipTable';
import { CustomTooltipBlack } from '../Tooltip/CustomTooltip';
import AgendaSubjectCard from './AgendaSubjectCard';

function AgendaDepartmentCard({
    deptKey,
    agendas,
    index,
    departmentGroups,
    handleDepartmentSorting,
    handleSubjectSorting,
    handleAgendaSorting,
    handleDelete
}) {
    const subjectGroups = subjectGroupsFromAgendas(agendas);    const tooltipList = transformGroups(departmentGroups);


    return (
        <Card sx={{ mb: 1, p: 0, backgroundColor: departmentCardColor, width: '100%', borderRadius: 2, boxShadow: 'none' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', m: 0, p: 0 }}>
                <Grid container spacing={0} sx={{ m: 0, p: 0, alignItems: 'center' }}>
                    <Grid item xs={1}>
                        <ButtonGroup>
                            <IconButton
                                onClick={() => handleDepartmentSorting(index, 'up')}
                                disabled={index === 0}
                            >
                                <ArrowUpwardIcon />
                            </IconButton>
                            <IconButton
                                onClick={() => handleDepartmentSorting(index, 'down')}
                                disabled={index === departmentGroups.length - 1}
                            >
                                <ArrowDownwardIcon />
                            </IconButton>
                        </ButtonGroup>
                    </Grid>
                    <Grid item xs={11}>
                        <CustomTooltipBlack
                            placement="top-start" // Tooltip, metnin sol üst köşesine göre açılır.
                            arrow
                            title={<SubjectTooltipTable tooltipList={tooltipList} />}
                        >
                            <Typography
                                sx={{
                                    m: 0,
                                    p: 0,
                                    textAlign: 'left',
                                    color: departmentCardTextColor,
                                    fontWeight: 450
                                }}
                            >
                                {deptKey} / Gündem Sayısı: {agendas.length}
                            </Typography>
                        </CustomTooltipBlack>
                    </Grid>


                </Grid>
                {subjectGroups.map(([subjectId, agendas], subjIndex) => (
                    <AgendaSubjectCard
                        key={subjectId}
                        subjectId={subjectId}
                        agendas={agendas}
                        index={subjIndex}
                        subjectGroups={subjectGroups}
                        handleSubjectSorting={(subjectIndex, direction) => handleSubjectSorting(deptKey, subjectIndex, direction)}
                        handleAgendaSorting={(subjectId, agendaIndex, direction, updatedAgenda) =>
                            handleAgendaSorting(deptKey, subjectId, agendaIndex, direction, updatedAgenda)
                        }
                        handleDelete={handleDelete}
                    />
                ))}
            </Box>
        </Card>

    );
}

export default AgendaDepartmentCard;
